import { reportAttendanceOperatorText } from '../const';

export const getBreadcrumbItem = (isOperator, reportDetail) => {
  if (isOperator) {
    return [
      {
        title: reportAttendanceOperatorText.titleText,
        href: '/report/attendance',
      },
    ];
  }
  return [
    {
      title: reportAttendanceOperatorText.titleText,
      href: '/report/attendance',
    },
    {
      title: `${reportDetail.operatorName} - ${reportDetail.periode}`,
      href: '/',
    },
  ];
};
